import { Component, inject, Input, signal } from '@angular/core';
import { Observable, take } from "rxjs";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

export interface IPlateActionsGroup {
  title: string;
  actions: IPlateAction[];
}

export interface IPlateAction {
  title: string;
  description: string;
  iconClass?: string;
  action: () => Observable<boolean>;
  disabled?: boolean;
}

@Component({
  selector: 'app-plates-actions-modal',
  standalone: true,
  imports: [],
  templateUrl: 'plates-actions-modal.component.html',
  styleUrl: 'plates-actions-modal.component.scss'
})
export class PlatesActionsModalComponent {
  private activeModal = inject(NgbActiveModal);

  @Input() header = '';
  @Input() subheader = '';
  @Input() iconClass = 'ic-form-20';
  @Input() actionGroups: IPlateActionsGroup[] = [];

  isLoading = signal(false);

  onPlateClick(action: IPlateAction): void {
    if (action.disabled) {
      return;
    }

    action.action()
      .pipe(take(1))
      .subscribe((actionResult) => {
        if (actionResult) {
          this.activeModal.close(actionResult);
        }

        this.isLoading.set(actionResult);
      });
  }

  close(): void {
    this.activeModal.dismiss();
  }
}
